import styled from "styled-components";
import { colors, fonts, header, transition } from "../../../styles/variables";
import { DisplayNoneSmDown } from "../../atoms/Display";
import breakpoints from "../../../styles/breakpoints";
import { extractNumberFromString } from "../../../helpers/tools";

export const Well = styled.div`
  background-color: ${colors.peach};
  border: 1px solid ${colors.black};
  padding: 10px 25px;
  margin-bottom: 25px;
`;

export const WellTitle = styled.h4`
  font-size: 20px;
  line-height: 25px;
  text-transform: uppercase;
`;

export const ListBullet = styled.ul`
  padding-inline-start: 30px;
  > li {
    margin: 15px 0;
  }
`;

export const ListSidebarNumbering = styled.ol`
  font-family: ${fonts.fontBauMedium};
  text-transform: uppercase;
  > li {
    font-size: 12px;
    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }
`;

export const ContentHolder = styled.div`
  counter-reset: numbering;
`;

export const ContentTitle = styled.h4`
  font-size: 20px;
  line-height: 25px;
  text-transform: uppercase;
  &:before {
    counter-increment: numbering;
    content: counter(numbering) ". ";
  }
`;

export const ListNumbering = styled.ol`
  padding-inline-start: 25px;
  > li {
    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }
`;

export const Bold = styled.b`
  font-family: ${fonts.fontBauMedium};
  font-size: 12px;
`;

export const Underline = styled.p`
  text-decoration: underline;
`;

export const Large = styled.p`
  line-height: 2.3;
`;

export const StyledDisplayNoneSmDown = styled(DisplayNoneSmDown)<{
  showHeaderBarFromChild: boolean;
}>`
  transition: ${transition.headerMenuBarTransition};
  ${breakpoints.smUp} {
    position: sticky;
    position: -webkit-sticky;
    left: 0;
    top: ${(props) =>
      !props.showHeaderBarFromChild
        ? header.withTabBarMobileHeight
        : `${extractNumberFromString(header.withTabBarMobileHeight) + 80}px`};
  }

  ${breakpoints.mdUp} {
    top: ${(props) =>
      !props.showHeaderBarFromChild
        ? header.withTabBarDesktopHeight
        : `${extractNumberFromString(header.withTabBarDesktopHeight) + 80}px`};
  }
`;
